import { generateTextures, getRandomInt } from '../framework/src/helpers';
import * as particles from 'pixi-particles';
import * as PIXI from "pixi.js-legacy";


export default class Coins {

    constructor(commander) {
        this.commander = commander;


        this.frames = [];
        this.container = new PIXI.Container();
        this.emitter = null;
    }

    create(layer, x, y) {
        for(let i = 0; i < 5; i++) {
            this.frames.push({
                framerate: 24,
                loop: true,
                textures: Coins._generateTextures()
            });
        }

        this.emitter = new particles.Emitter(this.container, this.frames, coinSettings);
        this.emitter.particleConstructor = particles.AnimatedParticle;
        this.emitter.updateOwnerPos(x, y);
        this.emitter.emit = false;



        layer.addChild(this.container);
    }

    run() {
        this.emitter.emit = true;
    }

    static _generateTextures() {
        let txt = generateTextures('coin_gold_', 1, 30, '.png', 5);

        let i = getRandomInt(0, txt.length);

        let txt1 = txt.slice(0, i);
        let txt2 = txt.slice(i);

        txt1.unshift(...txt2);
        return txt1;
    }

    stop() {
        this.emitter.emit = false;
        this.emitter.cleanup();
    }
}

const coinSettings = {
    "autoUpdate": true,
    "alpha": {
        "start": 0.97,
        "end": 1
    },
    "scale": {
        "start": 0.43,
        "end": 0.67,
        "minimumScaleMultiplier": 1
    },
    "speed": {
        "start": 1300,
        "end": 200,
        "minimumSpeedMultiplier": 0.5
    },
    "acceleration": {
        "x": 0,
        "y": 2000
    },
    "maxSpeed": 0,
    "startRotation": {
        "min": 215,
        "max": 315
    },
    "noRotation": false,
    "rotationSpeed": {
        "min": 0,
        "max": 0
    },
    "lifetime": {
        "min": 1.5,
        "max": 1.5
    },
    "blendMode": "normal",
    "frequency": 0.015,
    "emitterLifetime": -1,
    "maxParticles": 100,
    "pos": {
        "x": 0,
        "y": 0
    },
    "addAtBack": false,
    "spawnType": "circle",
    "spawnCircle": {
        "x": 0,
        "y": 0,
        "r": 200
    }
};